import { render, staticRenderFns } from "./ProjectQuoting.vue?vue&type=template&id=45e39cc7"
import script from "./ProjectQuoting.vue?vue&type=script&lang=js"
export * from "./ProjectQuoting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports